import React, { useEffect, useMemo, useState } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

import { TICKET_STATUS } from '@qbot-chat/qbot-uikit';
import { rSocket, ticketStore } from '../../store/FrontChatStore';
import {
  COOKIE_KEY_BRAND_ID,
  COOKIE_KEY_BRAND_NM,
  COOKIE_KEY_CHANNEL_ID,
  COOKIE_KEY_EMART_BRANCH_ID,
  COOKIE_KEY_EMART_BRANCH_NAME,
  COOKIE_KEY_TICKET_ID,
  COOKIE_KEY_USER_ID,
  EMART_THEMES,
  TICKET_FIELD_KEYS,
  COOKIE_KEY_SCENARIO_YN,
  COOKIE_KEY_TEL_NO,
  COOKIE_KEY_SCENARIO_ID,
  COOKIE_KEY_CHAT_YN,
} from '../../const/AppConst';
import { eventTrack } from '../../util/Utils';
import { PATH, chatPath } from '../../const/path';
import { COMPANY } from '../../const/company';
import { getChatCompanyId, setChatCompanyId } from '../../helper/SessionCookie';

import BTBMarket from './pages/btb/BTBMarket';
import QvPage from './pages/qv/QvPage';
import DaishinPage from './pages/daishin/DaishinPage';
import HyundairsPage from './pages/hyundairs/HyundairsPage';
import Skeleton from './pages/Skeleton';

import Styles from './Loading.module.scss';

import { ReactComponent as Check } from './assets/ic_24_check.svg';

// 회사별 로딩 화면. 등록되지 않은 회사는 BTBMarket 이 받는다
const COMPANY_PAGE = {
  [COMPANY.QV.id]: QvPage,
  [COMPANY.DAISHIN.id]: DaishinPage,
  [COMPANY.HYUNDAIRS.id]: HyundairsPage,
};

const ListItem = ({ text }) => (
  <div className={Styles.ListItem}>
    <div className={Styles.Oval}>
      <Check />
    </div>
    {text}
  </div>
);

ListItem.propTypes = {
  text: PropTypes.string.isRequired,
};

const Loading = ({ location, match }) => {
  const user_id = useMemo(() => Cookies.get(COOKIE_KEY_USER_ID), []);
  // const user_key = useMemo(() => Cookies.get(COOKIE_KEY_USER_KEY), []);
  const channelId = useMemo(() => Cookies.get(COOKIE_KEY_CHANNEL_ID), []);
  // const nickname = useMemo(() => Cookies.get(COOKIE_KEY_NICKNAME), []);
  const sid = useMemo(() => Cookies.get(COOKIE_KEY_SCENARIO_ID), []);
  const telNo = useMemo(() => Cookies.get(COOKIE_KEY_TEL_NO), []);
  const chatYn = useMemo(() => Cookies.get(COOKIE_KEY_CHAT_YN), []);

  // 회사 판별 — /init 이 심은 명시 선택(쿠키) 우선, 없으면 ARS 로그에서 해결 (/init2 경로)
  const [compId, setCompId] = useState(
    () => getChatCompanyId() || null,
  );
  // check-ars-expired 응답 대기 여부 — 응답 전 점검 화면으로 튀는 것 방지
  const [resolving, setResolving] = useState(true);

  const [channelUrl, setChannelUrl] = useState(null);
  const [error, setError] = useState(false);
  const [expired, setExpired] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [theme, setTheme] = useState(EMART_THEMES.EM);
  const [landing, setLanding] = useState(false);

  // const axiosWithTimeout = axios.create({ timeout: 10000 });

  const init = async () => {
    console.log('channelId : ' + channelId);

    // 세션 없이 직접 진입 (주소창 · / 리다이렉트 · 상담 재시작) — 만료 화면
    if (!channelId) {
      setExpired(true);
      return;
    }

    let channelCode;
    let chnlDts;
    let cbotCd;
    const isReloaded = location.state?.reload;

    let landingRequired = false;
    const isFromLanding = match.params.fromLanding === 'fromLanding';
    if (isReloaded) console.log('새로 진입. 유입로그 GA 기록..');

    let response;
    try {
      //response = await rSocket.requestChatApi(``, {});
      axios.defaults.baseURL = '/mp/api/v1';
      let params = {
        userId: user_id,
        chatBotType: telNo,
      };
      //response = await axios.post(`/channel-log/check-ars-expired/${user_id}?rn=${uuidv4()}`);
      response = await axios.post(`/channel-log/check-ars-expired`, params);
    } catch (err) {
      if (err.code === 'ECONNABORTED') {
        console.log('timeout');
        setLoaded(true);
      } else {
        setExpired(true);
      }
      return;
    }

    try {
      let arsChannelLog;
      if (response?.data) {
        const logs = response.data;
        const logMap = new Map(logs.map((log) => [log.type, log]));

        console.log(logMap);

        arsChannelLog = logMap.get('ARS');

        console.log(arsChannelLog);

        if (arsChannelLog) {
          const infloDts = new Date(arsChannelLog?.createdAt);
          //   const date = format(infloDts, 'yyyyMMdd');
          //   const time = format(infloDts, 'HHmmSS');

          Cookies.set(COOKIE_KEY_CHANNEL_ID, channelId, { expires: 1 });
          // Cookies.set(COOKIE_KEY_USER_KEY, user_key, {expires: 1});

          if (arsChannelLog?.branch?.id)
            Cookies.set(COOKIE_KEY_EMART_BRANCH_ID, arsChannelLog?.branch?.id, {
              expires: 1,
            });

          if (arsChannelLog?.branch?.name)
            Cookies.set(
              COOKIE_KEY_EMART_BRANCH_NAME,
              arsChannelLog?.branch?.name,
              { expires: 1 },
            );

          if (arsChannelLog?.brand?.id) {
            Cookies.set(COOKIE_KEY_BRAND_ID, arsChannelLog?.brandId, {
              expires: 1,
            });
            setTheme(EMART_THEMES[arsChannelLog?.brand?.id]);
          }

          if (arsChannelLog?.brand?.name) {
            Cookies.set(COOKIE_KEY_BRAND_NM, arsChannelLog?.brand?.name, {
              expires: 1,
            });
            document.title = `${arsChannelLog?.brand?.name} 디지털 상담`;
          }

          // 회사 판별 — 쿠키(/init 명시 선택) 우선, 없으면 ARS 로그의 회사
          // 하위 라우터(Chat/Close/Rating/Expired)가 이 쿠키를 읽으므로 여기서 보장
          const resolvedCompanyId =
            getChatCompanyId() ?? arsChannelLog?.brand?.companyId;
          if (resolvedCompanyId != null) {
            setChatCompanyId(resolvedCompanyId);
            setCompId(String(resolvedCompanyId));
          }

          landingRequired = arsChannelLog?.landingRequired;

          if (logMap.get('SDK')) {
            cbotCd = 'SDK';
          } else if (logMap.get('IOS')) {
            cbotCd = 'IOS';
          } else {
            cbotCd = 'AND';
          }

          chnlDts = infloDts;
          channelCode = arsChannelLog.type;

          if (isReloaded) {
            logs.forEach((log) => {
              const logCreatedAt = new Date(log?.createdAt);
              const date = format(logCreatedAt, 'yyyyMMdd');
              const time = format(logCreatedAt, 'HHmmSS');

              eventTrack(
                channelId,
                user_id,
                'event',
                `인입경로-${log.type}`,
                {
                  key1_timestamp_yyyymmdd: date,
                  key2_timestamp_hh24miss: time,
                },
                log.type,
              );
            });
          }
        }
      }

      // 고객의 아직 닫히지 않은 티켓이 있는지 확인하다.
      const channel = ticketStore.activeTickets?.find(
        (channel) => channel?.properties[`inflow-id`] === channelId,
      );
      if (channel) {
        console.log('기존 닫기전 티켓 확인됨.. ');
        rSocket.chatStore.setChannel({
          ...channel,
          status: TICKET_STATUS.ACTIVE,
        });
        setChannelUrl(channel.id);
      } else {
        // Use a user ID that is unique to your Sendbird application.
        let ticketCustomField = {};
        ticketCustomField[TICKET_FIELD_KEYS.inflowId] = channelId;
        ticketCustomField[TICKET_FIELD_KEYS.inflowType] = channelCode;
        ticketCustomField[TICKET_FIELD_KEYS.inflowAt] = chnlDts;
        ticketCustomField[TICKET_FIELD_KEYS.inflowCode] = cbotCd;
        if (arsChannelLog) {
          ticketCustomField[TICKET_FIELD_KEYS.branchName] =
            arsChannelLog?.branch?.name;
          ticketCustomField[TICKET_FIELD_KEYS.branchId] =
            arsChannelLog?.branch?.id;
          ticketCustomField[TICKET_FIELD_KEYS.branchTelno] =
            arsChannelLog?.branch?.telno;
          ticketCustomField[TICKET_FIELD_KEYS.brandId] =
            arsChannelLog?.brand?.id;
          ticketCustomField[TICKET_FIELD_KEYS.brandName] =
            arsChannelLog?.brand?.name;
        }
        // let {data:content} = await rSocket.requestChatApi(`/channel-log/greeting/message/content`, ticketCustomField);
        axios.defaults.baseURL = '/mp/api/v1';
        //let {data:content} = await axios.post(`/channel-log/greeting/message/content`, ticketCustomField);
        //console.log(content);
        if (landingRequired && !isFromLanding) {
          setLanding(true);
        } else {
          console.log('ticketCustomField : ', ticketCustomField);
          //COOKIE_KEY_SCENARIO_YN
          let channelParam = {
            properties: ticketCustomField,
            // greetingMessage: {
            //     type: MESSAGE_TYPE.GREETING,
            //     content: null
            // },
            scenario: {
              sid: sid,
            },
            team: {
              id: arsChannelLog?.branch?.team?.id,
            },
            companyId: arsChannelLog?.brand?.companyId,
            inflowType: 'IVR',
            chatYn: chatYn, // 임시
          };
          if (Cookies.get(COOKIE_KEY_SCENARIO_YN) == 'Y') {
            channelParam['scenario'] = { sid: sid };
          }
          console.log('channelParam : ', channelParam);
          let newChannel = await ticketStore.createChannel(channelParam);

          console.log('new Channel : ', newChannel);

          Cookies.set(COOKIE_KEY_TICKET_ID, newChannel.id);
          setChannelUrl(newChannel.id);
        }
      }
    } catch (err) {
      console.log(err);
      if (err.code === 'ECONNABORTED') {
        console.log('timeout');
        setLoaded(true);
      } else {
        setError(true);
      }
    }
  };

  useEffect(() => {
    console.log('loading useEffect');
    // 모든 종료 경로(조기 return · catch)에서 대기 해제 보장
    init().finally(() => setResolving(false));
  }, [channelId]);

  if (landing) return <Redirect to={PATH.LANDING} push={false} />;

  if (error) return <Redirect to={PATH.MAINTENANCE} push={false} />;

  if (expired) return <Redirect to={PATH.EXPIRED} push={false} />;

  if (loaded) return <Redirect to={PATH.LOADED} />;

  if (channelUrl) {
    return (
      <Redirect
        to={{
          pathname: chatPath(channelUrl),
          state: { from: 'loading', status: 'not-loaded' },
        }}
        push={false}
      />
    );
  }

  // 소켓 세션 가드 — 새로고침 등으로 sender 유실 시
  if (!ticketStore.sender?.id)
    return <Redirect to={PATH.MAINTENANCE} push={false} />;

  // 회사를 아직 모를 때만 대기 화면. 쿠키로 이미 아는 경우(/init 진입)는
  // 응답을 기다리지 않고 회사별 로딩 화면을 바로 띄운다
  if (!compId) {
    if (resolving) return <Skeleton />;
    return <Redirect to={PATH.MAINTENANCE} push={false} />;
  }

  // 회사별 로딩 화면은 자체 브랜딩을 쓰므로 emart 테마 변수를 넘기지 않는다
  const CompanyPage = COMPANY_PAGE[compId];
  if (CompanyPage) return <CompanyPage />;

  return <BTBMarket theme_style={EMART_THEMES[theme]} />;
};

Loading.propTypes = {};

export default withRouter(Loading);
